module.exports = __webpack_public_path__ + "static/media/male-cartoon-on-wheel-chair-copy-15.8677ff59.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/male-cartoon-on-wheel-chair-copy-15.svg
// module id = 2633
// module chunks = 0